import { WalletConfigV2 } from '@pancakeswap/ui-wallets'
import { WalletFilledIcon } from '@pancakeswap/uikit'
import { getOkxWalletProvider } from '@pancakeswap/wagmi/connectors/okxWallet'
import { getBitgetWalletProvider } from '@pancakeswap/wagmi/connectors/bitgetWallet'
import { ASSET_CDN } from './constants/endpoints'

export enum ConnectorNames {
  Particle = 'Particle',
  MetaMask = 'metaMask',
  Bitkeep = 'Bitkeep',
  Okx = 'Okx',
  Injected = 'injected',
  WalletConnect = 'walletConnect',
  BSC = 'bsc',
  Blocto = 'blocto',
  BybitWallet = 'BybitWallet',
  WalletLink = 'coinbaseWallet',
  Ledger = 'ledger',
  TrustWallet = 'trustWallet',
}

const isMetamaskInstalled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (window.ethereum?.isMetaMask) {
    return true
  }

  if (window.ethereum?.providers?.some((p) => p.isMetaMask)) {
    return true
  }

  return false
}

const walletsConfig = ({
  chainId,
  connect,
}: {
  chainId: number
  connect: (connectorID: ConnectorNames) => void
}): WalletConfigV2<ConnectorNames>[] => {
  return [
    {
      id: 'metamask',
      title: 'Metamask',
      icon: `${ASSET_CDN}newImages/wallet/metamask.png`,
      get installed() {
        return isMetamaskInstalled()
        // && metaMaskConnector.ready
      },
      connectorId: ConnectorNames.MetaMask,
      deepLink: 'https://metamask.app.link/dapp/agni.finance/',
      downloadLink: 'https://metamask.app.link/dapp/agni.finance/',
    },
    {
      id: 'BybitWallet',
      title: 'Bybit Wallet',
      icon: `${ASSET_CDN}newImages/wallet/bybit.png`,
      get installed() {
        return typeof window !== 'undefined' && Boolean((window as any).bybitWallet)
      },
      deepLink: 'https://www.bybit.com/en/web3',
      downloadLink: 'https://www.bybit.com/en/web3',
      connectorId: ConnectorNames.BybitWallet,
    },

    {
      id: 'bitkeep',
      title: 'Bitget Wallet',
      icon: `${ASSET_CDN}newImages/wallet/bitget.png`,
      get installed() {
        return getBitgetWalletProvider() !== undefined
      },
      connectorId: ConnectorNames.Bitkeep,
      deepLink: 'https://web3.bitget.com/wallet-download?type=2',
      downloadLink: 'https://web3.bitget.com/wallet-download?type=2',
    },
    {
      id: 'okex',
      title: 'OkX Wallet',
      icon: `${ASSET_CDN}newImages/wallet/okx.png`,
      get installed() {
        return getOkxWalletProvider() !== undefined
      },
      connectorId: ConnectorNames.Okx,
      deepLink: 'https://www.okx.com/web3',
      downloadLink: 'https://www.okx.com/web3',
    },

    {
      id: 'walletconnect',
      title: 'WalletConnect',
      icon: `${ASSET_CDN}newImages/wallet/walletconnect.png`,
      connectorId: ConnectorNames.WalletConnect,
    },
    {
      id: 'Particle',
      title: 'Particle',
      icon: `${ASSET_CDN}newImages/wallet/particle.png`,
      connectorId: ConnectorNames.Particle,
    },
    {
      id: 'binance',
      title: 'Binance Web3 Wallet',
      icon: `${ASSET_CDN}newImages/wallet/bsc.svg`,
      connectorId: ConnectorNames.BSC,
    },
    // {
    //   id: 'coinbase',
    //   title: 'Coinbase Wallet',
    //   icon: `${ASSET_CDN}/web/wallets/coinbase.png`,
    //   connectorId: ConnectorNames.WalletLink,
    // },
    // {
    //   id: 'trust',
    //   title: 'Trust Wallet',
    //   icon: `${ASSET_CDN}/web/wallets/trust.png`,
    //   connectorId: ConnectorNames.TrustWallet,
    //   get installed() {
    //     return !!getTrustWalletProvider()
    //   },
    //   deepLink: 'https://link.trustwallet.com/open_url?coin_id=20000714&url=https://pancakeswap.finance/',
    //   downloadLink: 'https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph',
    //   guide: {
    //     desktop: 'https://trustwallet.com/browser-extension',
    //     mobile: 'https://trustwallet.com/',
    //   },
    //   qrCode,
    // },

    // {
    //   id: 'opera',
    //   title: 'Opera Wallet',
    //   icon: `${ASSET_CDN}/web/wallets/opera.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean(window.ethereum?.isOpera)
    //   },
    //   downloadLink: 'https://www.opera.com/crypto/next',
    // },
    // {
    //   id: 'brave',
    //   title: 'Brave Wallet',
    //   icon: `${ASSET_CDN}/web/wallets/brave.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean(window.ethereum?.isBraveWallet)
    //   },
    //   downloadLink: 'https://brave.com/wallet/',
    // },
    // {
    //   id: 'math',
    //   title: 'MathWallet',
    //   icon: `${ASSET_CDN}/web/wallets/mathwallet.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean(window.ethereum?.isMathWallet)
    //   },
    //   qrCode,
    // },
    // {
    //   id: 'tokenpocket',
    //   title: 'TokenPocket',
    //   icon: `${ASSET_CDN}/web/wallets/tokenpocket.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean(window.ethereum?.isTokenPocket)
    //   },
    //   qrCode,
    // },
    // {
    //   id: 'safepal',
    //   title: 'SafePal',
    //   icon: `${ASSET_CDN}/web/wallets/safepal.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean((window.ethereum as ExtendEthereum)?.isSafePal)
    //   },
    //   downloadLink:
    //     'https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa',
    //   qrCode,
    // },
    // {
    //   id: 'coin98',
    //   title: 'Coin98',
    //   icon: `${ASSET_CDN}/web/wallets/coin98.png`,
    //   connectorId: ConnectorNames.Injected,
    //   get installed() {
    //     return (
    //       typeof window !== 'undefined' &&
    //       (Boolean((window.ethereum as ExtendEthereum)?.isCoin98) || Boolean(window.coin98))
    //     )
    //   },
    //   qrCode,
    // },
    // {
    //   id: 'blocto',
    //   title: 'Blocto',
    //   icon: `${ASSET_CDN}/web/wallets/blocto.png`,
    //   connectorId: ConnectorNames.Blocto,
    //   get installed() {
    //     return typeof window !== 'undefined' && Boolean((window.ethereum as ExtendEthereum)?.isBlocto)
    //       ? true
    //       : undefined // undefined to show SDK
    //   },
    // },
    // {
    //   id: 'ledger',
    //   title: 'Ledger',
    //   icon: `${ASSET_CDN}/web/wallets/ledger.png`,
    //   connectorId: ConnectorNames.Ledger,
    // },
  ]
}

export const createWallets = (chainId: number, connect: any) => {
  const hasInjected = typeof window !== 'undefined' && !window.ethereum
  const config = walletsConfig({ chainId, connect })
  return hasInjected && config.some((c) => c.installed && c.connectorId === ConnectorNames.Injected)
    ? config // add injected icon if none of injected type wallets installed
    : [
        ...config,
        {
          id: 'injected',
          title: 'Injected',
          icon: WalletFilledIcon,
          connectorId: ConnectorNames.Injected,
          installed: typeof window !== 'undefined' && Boolean(window.ethereum),
        },
      ]
}

const docLangCodeMapping: Record<string, string> = {
  it: 'italian',
  ja: 'japanese',
  fr: 'french',
  tr: 'turkish',
  vi: 'vietnamese',
  id: 'indonesian',
  'zh-cn': 'chinese',
  'pt-br': 'portuguese-brazilian',
}

export const getDocLink = (code: string) =>
  docLangCodeMapping[code]
    ? `https://docs.pancakeswap.finance/v/${docLangCodeMapping[code]}/get-started/wallet-guide`
    : `https://docs.pancakeswap.finance/get-started/wallet-guide`
